/**
 * AreasSection.js — Practice area browse section on the home page.
 *
 * Displays a grid of practice area buttons. When a practice area is selected,
 * it loads matching products from the pre-loaded ProductsData and renders them
 * as ProductGridNew2 cards.
 *
 * Props:
 *  - ProductsData {object}                Raw Shopify product data keyed by handle.
 *  - Program_structure_images {Array}     Slug-to-image mapping.
 *  - Program_structure_color {Array}      Slug-to-colour mapping.
 *  - AddtoCart {Function}                 Adds a variant to the Shopify cart.
 *  - AddtoWishlist {Function}             Toggles a product in the wishlist.
 *  - getAllWishlist {Array}                Current wishlist slugs.
 *  - is_ten_minite_less {Function}        Returns true if event starts in <10 min.
 *  - program_date_is_gone_or_not {Function} Returns true if event date has passed.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, { useState, useEffect, useCallback } from "react";
import {Container, Row, Col, Button} from "react-bootstrap";
import ProductGridNew2 from "../ProductListing/ProductGrid/ProductGridNew2";

import LeftArr from "../../images/left-arr.svg";
import RightArr from "../../images/right-arr.svg";

export const AreasSection = (props) => {

  const [practice_areas_result, set_practice_areas_result] = useState([]);
  const practice_areas = [
    "Advocacy",
    "Building & Construction",
    "Business & Contracts",
    "Consumer",
    "Corporate & In-House Counsel",
    "Costs",
    "Criminal",
    "Employment & Workplace Relations",
    "Ethics",
    "Family",
    "Finance, Tax, Superannuation",
    "Government, Privacy & FOI",
    "Health & Aged Care",
    "Insolvency & Restructuring",
    "Intellectual Property",
    "Litigation & Dispute Resolution",
    "Migration",
    "Personal Injury & Medico-Legal",
    "Planning & Environment",
    "Professional Skills & Practice Management",
    "Property & Leases",
    "Sports Law",
    "Trusts & Succession Planning",
    "Wills & Estates",
  ];
  const load_per_page = 12;
  const [total_products, set_total_products] = useState(0);
  const [page, set_page] = useState(1);
  const [practice_courses, set_practice_courses] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const getAllWishlist =
    localStorage.getItem("wishlist_item") !== undefined &&
    localStorage.getItem("wishlist_item") !== "undefined" &&
    localStorage.getItem("wishlist_item") !== null
      ? JSON.parse(localStorage.getItem("wishlist_item"))
      : [];
  /***
   * Remove special charachter
   */
  const RemoveSpecialChar = (StringText) => {
    if (StringText !== null && StringText !== undefined) {
      return StringText.toLowerCase().split("&").join("and").split(",").join(" ").split(" ").join("-");
    }
  };
  let temp = [];
  props.selectedProgram.forEach((val) => {
    val.split("|").forEach((pval) => {
      if (pval !== "") {
        temp.push(RemoveSpecialChar(pval));
      }
    });
  });
  const [selected_practice_areas, set_selected_practice_areas] = useState(temp);
  /***
   * Is filter Tag checked
   */

  const isTagCHecked = (TagValue) => {
    if (Does_Tag_isPracticeArea(TagValue).length > 0 && selected_practice_areas !== undefined) {
      return selected_practice_areas.includes(RemoveSpecialChar(TagValue));
    }
  };

  const Does_Tag_isPracticeArea = (PracticeValue) => {
    return practice_areas.filter((val) => {
      return val === PracticeValue;
    });
  };

  const flatten = (arr) => {
    return arr.reduce(function (flat, toFlatten) {
      return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
  };

  /****
   * All filter list
   */
  const AllFilterList = (RequestTag) => {
    var ArraysTemp = [[practice_areas]];
    return flatten(ArraysTemp).includes(RequestTag) && isTagCHecked(RequestTag);
  };
  /***
   * Compare array value
   */
  function intersect_arrays(a, b) {
    var sorted_a = a.concat().sort();
    var sorted_b = b.concat().sort();
    var common = [];
    var a_i = 0;
    var b_i = 0;

    while (a_i < a.length && b_i < b.length) {
      if (sorted_a[a_i] === sorted_b[b_i]) {
        common.push(sorted_a[a_i]);
        a_i++;
        b_i++;
      } else if (sorted_a[a_i] < sorted_b[b_i]) {
        a_i++;
      } else {
        b_i++;
      }
    }
    return common;
  }
  /****
   * Fillter 3 dot toogle
   */
  const [dotToogle, setdotToogle] = useState(false);

  const CARDS_INITIAL = 8;
  const CARDS_PER_LOAD = 8;
  const MOBILE_PER_PAGE = 8;
  const [displayCount, setDisplayCount] = useState(CARDS_INITIAL);
  const [mobilePage, setMobilePage] = useState(1);

  const handleClick = () => {
    setLoading(true);
    setTimeout(function () {
      set_page(page + 1);
      if (selected_practice_areas !== undefined && selected_practice_areas.length > 0) {
        set_practice_courses(practice_areas_result.slice(0, load_per_page * (page + 1)));
      } else {
        set_practice_courses(props.products.slice(0, load_per_page * (page + 1)));
      }
      setLoading(false);
    }, 1000);
  };

  function practice_areas_updated(val) {
    if (!selected_practice_areas.includes(val)) {
      set_selected_practice_areas([...selected_practice_areas, val]);
    } else {
      let arr = selected_practice_areas.filter(function (item) {
        return item !== val;
      });

      set_selected_practice_areas(arr);
    }
  }
  const getProductData = (product) => {
    try {
      // Handle if product is an array with product at index 1
      const productObj = Array.isArray(product) ? product[1] : product;

      if (!productObj || typeof productObj !== "object") {
        return null;
      }

      return productObj;
    } catch (error) {
      console.error("Error extracting product data:", error);
      return null;
    }
  };

  const getMetafieldValue = (productObj, key) => {
    try {
      if (!productObj.metafields || !Array.isArray(productObj.metafields)) {
        return null;
      }

      const metafield = productObj.metafields.find((m) => m.key === key);
      return metafield ? JSON.parse(metafield.value) : null;
    } catch (error) {
      console.error(`Error parsing metafield ${key}:`, error);
      return null;
    }
  };

  const practice_areas_search = useCallback(() => {
    let new_selected_practice_areas = [];

    if (selected_practice_areas.length > 0) {
      props.products.forEach(function (val) {
        const product = getProductData(val);
        if (!product) return;

        const productData = getMetafieldValue(product, "all_data");
        if (!productData || !productData.Practising_Areas__c) return;

        const practice_areas_array = productData.Practising_Areas__c;
        const lower_program = practice_areas_array.split(";").map((v) => RemoveSpecialChar(v));

        // Check if product matches ANY of the selected practice areas (OR condition)
        const matchesAnySelected = selected_practice_areas.some((selectedArea) => {
          const selectedPractise_user = selectedArea.split("|").map((v) => RemoveSpecialChar(v));
          return intersect_arrays(lower_program, selectedPractise_user).length !== 0;
        });

        if (matchesAnySelected) {
          new_selected_practice_areas = [...new_selected_practice_areas, val];
        }
      });

      set_practice_areas_result(new_selected_practice_areas);
      set_practice_courses(new_selected_practice_areas.slice(0, load_per_page));
      set_total_products(new_selected_practice_areas.length);
      set_page(1);
      setDisplayCount(CARDS_INITIAL);
      setMobilePage(1);
    } else {
      set_total_products(props.products.length);
      set_practice_courses(props.products.slice(0, load_per_page));
      setDisplayCount(CARDS_INITIAL);
      setMobilePage(1);
    }
  }, [
    selected_practice_areas,
    props.products,
    load_per_page,
    CARDS_INITIAL,
  ]);

  useEffect(() => {
    if (props.products !== undefined) {
      practice_areas_search();
    }
  }, [selected_practice_areas,props.products,practice_areas_search]);

  useEffect(() => {
    if (props.products !== undefined) {
      practice_areas_search();
    }
  }, [props.products,practice_areas_search,selected_practice_areas]);

  return (
    <div className="areas_wrapper">
      <Container>
        {practice_areas !== undefined && practice_areas.length > 0 ? (
          <>
            <div className="title_wrap text-center" key="500">
              <h2 className="text-primary">Top Practice Areas</h2>
            </div>
            <div className="fillter_wrapper">
              <div className={`filter_list_wrapper${dotToogle ? ' is-expanded' : ''}`} style={dotToogle ? {height: "auto"} : {}}>
                {/* <label className='filter_title'>Filter by:</label> */}
                {practice_areas.map((TagName, key) => {
                  return (
                    <div className="filter_list" key={key + "ss"}>
                      <div className="form-check">
                        <div
                          className={AllFilterList(TagName) ? "form-check-label active" : "form-check-label"}
                          id={RemoveSpecialChar(TagName)}
                          onClick={() => practice_areas_updated(RemoveSpecialChar(TagName))}
                        >
                          {TagName}
                        </div>
                      </div>
                    </div>
                  );
                })}
                {!dotToogle ? (
                  <div className="filter_list_more" onClick={() => setdotToogle(true)}>
                    ...
                  </div>
                ) : null}
              </div>
            </div>
          </>
        ) : null}
        {/* ── Show-more — all breakpoints, same as desktop (Figma 55:39728) ── */}
        <div>
          <Row>
            {practice_courses === undefined || practice_courses.length === 0 ? (
              <Col lg={12} key="no_product_d">
                <div className="no_product_found text-center">No Courses Found</div>
              </Col>
            ) : (
              practice_courses.slice(0, displayCount).map(function (single_product, index) {
                const product_data = getProductData(single_product);
                if (!product_data) return null;
                const product_title = product_data.title;
                const product_slug = product_data.handle;
                const priceRange = product_data.priceRange;
                const product_final_data = getMetafieldValue(product_data, "all_data");
                return (
                  <Col xs={12} md={6} lg={3} key={"d" + index}>
                    <ProductGridNew2
                      key={"d" + index + "poi"}
                      program_date_is_gone_or_not={props.program_date_is_gone_or_not}
                      is_ten_minite_less={props.is_ten_minite_less}
                      Program_structure_images={props.Program_structure_images}
                      getAllWishlist={props.getAllWishlist || getAllWishlist}
                      AddtoWishlist={props.AddtoWishlist}
                      product={product_data}
                      AddtoCart={props.AddtoCart}
                      priceRange={priceRange}
                      product_slug={product_slug}
                      product_title={product_title}
                      product_data={product_final_data}
                      GAurl={props.GAurl}
                    />
                  </Col>
                );
              })
            )}
          </Row>
          {practice_courses.length > 0 && (displayCount < practice_courses.length || practice_courses.length < total_products) ? (
            <div className="btn_wrap text-center">
              <div className="text">
                Showing {Math.min(displayCount, practice_courses.length)} of {total_products} Courses
              </div>
              <Button
                variant="primary"
                disabled={isLoading}
                onClick={() => {
                  const next = displayCount + CARDS_PER_LOAD;
                  setDisplayCount(next);
                  if (next >= practice_courses.length && practice_courses.length < total_products) {
                    handleClick();
                  }
                }}
              >
                {isLoading ? "Loading…" : "Show more"}
              </Button>
            </div>
          ) : null}
        </div>

        {/* ── Mobile: paginated ── */}
        {(() => {
          const mobileStart = (mobilePage - 1) * MOBILE_PER_PAGE;
          const mobileEnd = mobilePage * MOBILE_PER_PAGE;
          const totalMobilePages = total_products > 0 ? Math.ceil(total_products / MOBILE_PER_PAGE) : 1;

          const goToMobilePage = (page) => {
            if (page < 1 || page > totalMobilePages || page === mobilePage || isLoading) return;
            if (document.activeElement) document.activeElement.blur();
            if (page * MOBILE_PER_PAGE > practice_courses.length && practice_courses.length < total_products) {
              handleClick();
            }
            setMobilePage(page);
          };

          const pageNums = (() => {
            const start = Math.max(1, Math.min(mobilePage - 1, totalMobilePages - 2));
            const end = Math.min(totalMobilePages, start + 2);
            const nums = [];
            for (let i = start; i <= end; i++) nums.push(i);
            return nums;
          })();

          const mobileCards = practice_courses.slice(mobileStart, mobileEnd);

          return (
            <div className="d-none">
              <Row className="g-4">
                {mobileCards.length === 0 ? (
                  <Col xs={12} key="no_product_m">
                    <div className="no_product_found text-center">No Courses Found</div>
                  </Col>
                ) : (
                  mobileCards.map(function (single_product, index) {
                    const product_data = getProductData(single_product);
                    if (!product_data) return null;
                    const product_title = product_data.title;
                    const product_slug = product_data.handle;
                    const priceRange = product_data.priceRange;
                    const product_final_data = getMetafieldValue(product_data, "all_data");
                    return (
                      <Col md={6} xs={12} key={"m" + index}>
                        <ProductGridNew2
                          key={"m" + index + "poi"}
                          program_date_is_gone_or_not={props.program_date_is_gone_or_not}
                          is_ten_minite_less={props.is_ten_minite_less}
                          Program_structure_images={props.Program_structure_images}
                          getAllWishlist={props.getAllWishlist || getAllWishlist}
                          AddtoWishlist={props.AddtoWishlist}
                          product={product_data}
                          AddtoCart={props.AddtoCart}
                          priceRange={priceRange}
                          product_slug={product_slug}
                          product_title={product_title}
                          product_data={product_final_data}
                          GAurl={props.GAurl}
                        />
                      </Col>
                    );
                  })
                )}
              </Row>
              {totalMobilePages > 1 ? (
                <div className="areas-mobile-pagination">
                  <button
                    className="areas-pagination-arrow"
                    onClick={() => goToMobilePage(mobilePage - 1)}
                    disabled={mobilePage === 1 || isLoading}
                    aria-label="Previous page"
                  >
                    <img src={LeftArr} alt="" width="12" height="12" />
                  </button>
                  <div className="areas-pagination-pages">
                    {pageNums.map(num => (
                      <button
                        key={num}
                        className={`areas-pagination-page${num === mobilePage ? ' active' : ''}`}
                        onClick={() => goToMobilePage(num)}
                        disabled={isLoading}
                      >
                        {num}
                      </button>
                    ))}
                  </div>
                  <button
                    className="areas-pagination-arrow"
                    onClick={() => goToMobilePage(mobilePage + 1)}
                    disabled={mobilePage === totalMobilePages || isLoading}
                    aria-label="Next page"
                  >
                    <img src={RightArr} alt="" width="16" height="16" />
                  </button>
                </div>
              ) : null}
            </div>
          );
        })()}
      </Container>
    </div>
  );
};

export default AreasSection;
